import { Badge, type BadgeProps } from "@mantine/core";
import { statusColors, type StatusDomain } from "@how/design-system";

export type StatusValue<D extends StatusDomain> = keyof (typeof statusColors)[D] & string;

export interface StatusBadgeProps<D extends StatusDomain> extends Omit<
  BadgeProps,
  "color" | "children"
> {
  readonly domain: D;
  readonly value: StatusValue<D>;
  /** Override the displayed label; defaults to the value with underscores replaced by spaces. */
  readonly label?: string;
}

/** Domain-status badge colored from the shared statusColors module, so a status looks the same everywhere. */
export function StatusBadge<D extends StatusDomain>({
  domain,
  value,
  label,
  ...rest
}: StatusBadgeProps<D>) {
  const color = statusColors[domain][value] as string;
  return (
    <Badge variant="light" color={color} {...rest}>
      {label ?? value.replace(/_/g, " ")}
    </Badge>
  );
}
